module.exports = __webpack_public_path__ + "static/img/3.ee19638.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/3.png
// module id = kcTn
// module chunks = 0